import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import { useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import AxiosApi from "../Helper/axios.api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Select } from "react-select-virtualized";
import { validateAll } from "indicative/validator";

export default function EditAnimator(props) {
  const auth = useSelector((state) => state.auth);
  const [errors, setErrors] = useState({});
  const [animator,setAnimator] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(props);
    setErrors({});
    setAnimator(props.animator);
  }, [props.animator]);

  const hideModal = () => {
    props.setAnimator(null);
    setErrors({});
  }
  const onChangeValue = ({name, value}) => {
    setAnimator((animator) => ({
      ...animator,
      [name]: value,
    }));
  }

  const submitChanges = (e) => {
    setLoading(false);

    e.preventDefault();
    const rules = {
      id: "required|string",
      name: "required|string",
      priority: "required|integer|above:-1",
    };

    validateAll(animator, rules)
      .then(async () => {
        setErrors({});
        const data = {
          user_id: auth.userDeatils.user_id,
          id: animator.id,
          name: animator.name,
          state: animator.state.value,
          priority: animator.priority,
        };
        AxiosApi
          .withToken(auth.accessToken, "admin/worker/edit", "post", data)
          .then((res) => {
            if (res.status) {
              toast.success(res.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              hideModal();
              props.setIsUpdate(!props.isUpdate);
            } else {
              toast.error(res.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((valErrors) => {
        setLoading(false);
        const newErrors = {};
        valErrors.forEach(
          (error) => (newErrors[error.field] = error.message)
        );
        setErrors(newErrors);
        setLoading(false);
      })
  };

  return (
    <Modal
      size="lg"
      show={props.animator}
      onHide={() => {
        hideModal();
      }}
      aria-labelledby="example-modal-sizes-title-lg"
      className="advanced-modal"
      animation={true}
      centered
      style={{ zIndex: "999999" }}
    >
      <Modal.Header>
        <Modal.Title id="example-modal-sizes-title-lg">
          <div id={loading ? "pageLoader" : ""} />
          <h5 className="modal-title">Edit Animator</h5>
        </Modal.Title>
        <button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          onClick={() => {
            hideModal();
          }}
        >
          <i
            style={{ fontSize: 20 }}
            className="fa fa-times"
            aria-hidden="true"
          ></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="profile-form">
          <div className="profile-form-block">
            <div className="row my-2">
              <div className="col-md-6">
                <div className="form-group">
                  <Label className="form-label mb-2 d-flex align-items-center" style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#495057'
                  }}>
                    <i className="fa fa-lock me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                    ID
                  </Label>
                  <Input
                    type="text"
                    name="id"
                    readOnly
                    disabled
                    value={animator?.id || ''}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <Label className="form-label mb-2 d-flex align-items-center" style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#495057'
                  }}>
                    <i className="fa fa-edit me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                    Name
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    value={animator?.name || ''}
                    onChange={(e) => onChangeValue(e.target)}
                    invalid={errors.name ? true : false}
                    style={{
                      borderRadius: '4px',
                      border: errors.name ? '2px solid #dc3545' : '1px solid #ced4da',
                      backgroundColor: '#ffffff',
                      padding: '8px 12px',
                      fontSize: '14px',
                      fontWeight: '400',
                      transition: 'all 0.2s ease-in-out',
                      boxShadow: errors.name ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = errors.name ? '#dc3545' : '#007bff';
                      e.target.style.boxShadow = errors.name ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = errors.name ? '#dc3545' : '#ced4da';
                      e.target.style.boxShadow = errors.name ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6">
                <div className="form-group">
                  <Label className="form-label mb-2 d-flex align-items-center" style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#495057'
                  }}>
                    <i className="fa fa-edit me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                    State
                  </Label>
                  <Select
                    value={animator?.state}
                    options={props.stateOptions}
                    onChange={(option) => (option && onChangeValue({name: 'state', value:option}))}
                    placeholder="State"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <Label className="form-label mb-2 d-flex align-items-center" style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#495057'
                  }}>
                    <i className="fa fa-edit me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                    Priority
                  </Label>
                  <Input
                    type="number"
                    name="priority"
                    value={animator?.priority || 0}
                    min={0}
                    onChange={(e) => onChangeValue(e.target)}
                    invalid={errors.priority ? true : false}
                    style={{
                      borderRadius: '4px',
                      border: errors.priority ? '2px solid #dc3545' : '1px solid #ced4da',
                      backgroundColor: '#ffffff',
                      padding: '8px 12px',
                      fontSize: '14px',
                      fontWeight: '400',
                      transition: 'all 0.2s ease-in-out',
                      boxShadow: errors.priority ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = errors.priority ? '#dc3545' : '#007bff';
                      e.target.style.boxShadow = errors.priority ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = errors.priority ? '#dc3545' : '#ced4da';
                      e.target.style.boxShadow = errors.priority ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6">
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-primary mx-2 mt-4"
                    onClick={submitChanges}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
